export const icons = {
  allResources: 'common-all-resources',
  barometricPressure: 'common-barometric-pressure',
  buildings: 'common-buildings',
  co2: 'common-co2',
  coGen: 'common-co2',
  comparisons: 'common-comparisons',
  competitions: 'common-competitions',
  compost: 'common-compost',
  cooling: 'common-cooling',
  electricity: 'common-electricity',
  energy: 'common-total-energy',
  events: 'common-events',
  fuel: 'common-fuel',
  fueloil: 'common-fuel',
  gas: 'common-natural-gas',
  geothermal: 'common-geothermal',
  grayWater: 'common-gray-water',
  greenFeatures: 'common-green-features',
  heating: 'common-heating-air',
  heatingAir: 'common-heating-air',
  heatingWater: 'common-heating-water',
  home: 'common-home',
  hotWater: 'common-heating-water',
  humidity: 'common-humidity',
  humidityIndoors: 'common-humidity',
  intro: 'common-intro',
  irradiancePv: 'common-solar-pv',
  naturalGas: 'common-natural-gas',
  occupancy: 'common-occupancy',
  occupants: 'common-occupancy',
  occupiedArea: 'common-occupancy',
  other: 'common-unspecified-meter',
  percentOccupied: 'common-occupancy',
  precipitation: 'common-precipitation',
  pv: 'common-solar-pv',
  recycling: 'common-trash-recycling',
  solarPv: 'common-solar-pv',
  solarThermal: 'common-solar-thermal',
  temperature: 'common-temperature',
  totalEnergy: 'common-total-energy',
  totalenergy: 'common-total-energy',
  trashLandfill: 'common-trash-landfill',
  trashRecycling: 'common-trash-recycling',
  unspecifiedMeter: 'common-unspecified-meter',
  waste: 'common-trash-landfill',
  water: 'common-water',
  weather: 'common-weather',
  wind: 'common-wind',
  windDirection: 'common-wind-direction',
  windSpeed: 'common-wind',
};

// Provides a fallback if icon not found.
// Returns "other" icon on key misses.
export const getIconName = (slug, defaultSlug) => {
  return icons[slug] || icons[defaultSlug] || icons.other;
};
